import { Button, Loader, Table } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';

import { ACTION_MESSAGES } from '@brokerage/utils/custom_hooks/useNotification';
import { AgencyContext } from '@brokerage/contexts/AgencyContext';
import { Api } from '@brokerage/utils/Api';
import EditDrawer from './notification_triggers/Edit';
import { NOTIFICATION_TRIGGERS } from '@itds/Constants';
import { useParams } from 'react-router-dom';

const NotificationTriggers = () => {
  const params = useParams();
  const { setNotification } = useContext(AgencyContext);

  const [triggers, setTriggers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trigger, setTrigger] = useState(null);

  useEffect(() => {
    Api.loadIxnProducts({ agency_id: params.agency_id }).then(({ data }) => {
      const filteredProducts = data.filter(
        p => p.type === 'BgaQuoter' || p.type === 'WebsiteQuoter' || p.type === 'MobileApp'
      );

      setProducts(filteredProducts);
    });
  }, []);

  useEffect(() => {
    loadAgencyNotificationTriggers();
  }, [products]);

  const loadAgencyNotificationTriggers = () => {
    setLoading(true);

    Api.loadAgencyNotificationTriggers(params.agency_id).then(({ data }) => {
      const filtered_triggers = data.filter(nt => !nt.owner_id);
      const triggers_with_products = filtered_triggers.map(trigger => ({
        ...trigger,
        product: products.find(it => it.type === trigger.product_type)
      }));

      setTriggers(triggers_with_products);

      setLoading(false);
    });
  };

  const handleDelete = (id, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    Api.deleteNotificationTrigger(id).then(() => {
      loadAgencyNotificationTriggers();
      setNotification(ACTION_MESSAGES.AGENCIES.TRIGGER.DELETE);
    });
  };

  const handleSave = () => {
    loadAgencyNotificationTriggers();
    setTrigger(null);
    setNotification(ACTION_MESSAGES.AGENCIES.TRIGGER.SAVE);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <EditDrawer
        agencyId={params.agency_id}
        onClose={setTrigger.bind(null, null)}
        onSave={handleSave}
        products={products}
        show={!!trigger}
        trigger={trigger}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={setTrigger.bind(null, {})}>New Trigger</Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'trigger',
            label: 'Event',
            render: trigger => NOTIFICATION_TRIGGERS.find(t => t.value === trigger.trigger).label
          },
          {
            id: 'product_type',
            label: 'Product',
            render: trigger => {
              if (!trigger.product_id) {
                return 'All Products';
              }
              const product = trigger.product;

              return `${trigger.product_type} (${product?.name})`;
            }
          },
          {
            id: 'notification_type',
            label: 'Delivery Method'
          },
          {
            id: 'actions',
            render: nt => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, nt.id)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={triggers}
        onRowClick={setTrigger}
        placeholder='No Notification Triggers Found'
      />
    </>
  );
};

export default NotificationTriggers;
